import { Select } from "ant-design-vue";
import "ant-design-vue/dist/antd.less";
import { Component, Vue, Prop } from "vue-property-decorator";
import { CommonLocale } from "@/locales/localeid";
import { fmtMsg } from "commonui";
import { VersionGroupModel } from "@/services/version-group";
import LabelText from "@/components/label-text/label-text.vue";

@Component({
	components: {
		"a-select": Select,
		"a-select-option": Select.Option,
		LabelText
	}
})
export default class VersionGroupSelect extends Vue {
	@Prop({ default: [] }) versionGroups!: VersionGroupModel[];
	@Prop() value!: string;
	@Prop() hideLabel!: boolean;
	@Prop() disabled!: boolean;

	get commonFieldVersionGroupText(): string {
		return fmtMsg(CommonLocale.CommonFieldVersionGroup);
	}

	onVersionGroupChanged(value: string): void {
		this.$emit("change", value);
		this.$emit(
			"onVersionGroupChanged",
			this.versionGroups.find((v) => v.id === value)
		);
	}
}
